<script lang="ts">
    export let handleCloseEvent: () => void;
</script>

<div class="panel-block is-active">
    <div class="panel-block is-active">
        <div class="columns">
            <div class="column is-11">
                <div class="field-body field-margin">
                    <div class="field">
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Tag-Gruppe"
                                name="postalCode"
                            />
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Tag-optionen"
                                name="city"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-1">
                <span class="panel-icon" on:click={() => handleCloseEvent()}>
                    <i class="fas fa-times" />
                </span>
            </div>
        </div>
    </div>
</div>

<style>
    .panel-block {
        width: 100%;
    }
</style>
